import { RouteRecordRaw } from "vue-router";

const routes: Readonly<RouteRecordRaw[]> = [
  {
    path: "/bots",
    name: "Bots",
    meta: {
      layout: "default",
    },
    component: () => import("@/modules/Bots/pages/PIndex.vue"),
  },
  {
    path: "/bots/:botId",
    name: "BotsSingle",
    meta: {
      layout: "default",
    },
    component: () => import("@/modules/Bots/pages/PSingle.vue"),
  },
  {
    path: "/bots/:botId/coin/:coinId",
    name: "BotsCoinSingle",
    meta: {
      layout: "default",
    },
    component: () => import("@/modules/Bots/pages/PSingleCoin.vue"),
  },
  {
    path: "/bots/:botId/coin/:coinId/orders-by-pair",
    name: "BotsCoinSingleOrders",
    meta: {
      layout: "default",
    },
    component: () => import("@/modules/Bots/pages/PSingleCoinOrders.vue"),
  },
  {
    path: "/bots/add",
    name: "BotsAdd",
    meta: {
      layout: "default",
    },
    component: () => import("@/modules/Bots/pages/PAdd.vue"),
  },
  {
    path: "/bots/edit/:botId",
    name: "BotsEdit",
    meta: {
      layout: "default",
    },
    component: () => import("@/modules/Bots/pages/PEdit.vue"),
  },
];

export default routes;
